export const NETFLIX_COLORS = {
  // Primary palette - Netflix professional dark theme
  background: '#000000',
  backgroundDark: '#0f0f0f',
  backgroundSecondary: '#1a1a1a',
  surface: '#262626',
  surfaceHover: '#3a3a3a',
  primary: '#ff6b00',
  primaryHover: '#ff8533',
  accentGold: '#ffd700',
  accent: '#ffd700',
  danger: '#dc143c',
  dangerHover: '#ff1744',
  white: '#ffffff',

  // Text
  textPrimary: '#ffffff',
  textSecondary: '#b3b3b3',
  textTertiary: '#808080',

  // Other
  border: 'rgba(255,255,255,0.1)',
  borderLight: 'rgba(255,255,255,0.15)',
  scrim: 'rgba(0,0,0,0.7)',
};

export const NETFLIX_SPACING = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

export const NETFLIX_TYPOGRAPHY = {
  heroTitle: {
    fontSize: 48,
    fontWeight: '700',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
  },
  cardTitle: {
    fontSize: 12,
    fontWeight: '600',
  },
  body: {
    fontSize: 13,
    fontWeight: '400',
  },
  caption: {
    fontSize: 11,
    fontWeight: '400',
  },
};
